import { FilterOptionKeys, GoalFilterDocument } from '@griply/types';
import {
  getGoalListControlDocument,
  getGoalListEntityUpdate,
  getGoalListGroupOptions,
  goalAndProjectFilterSections,
  goalAndProjectListFilters,
} from '@griply/utils';
import { useUpdateLifeArea } from 'features/life-areas';
import React, { useMemo } from 'react';
import { GoalListFilterButton } from 'shared/components/connected/goal-list-filter-button';
import { LifeArea } from 'shared/types/life-area';

// Already one life area, and holds both kinds — drop Life area, keep Type.
// The roadmap lists the goals themselves, so grouping by goal has no meaning here.
const groupByModes = getGoalListGroupOptions({ hideLifeArea: true });
const filters = goalAndProjectListFilters.filter(
  (filter) => filter !== FilterOptionKeys.LifeArea,
);

export type LifeAreaRoadmapFilterButtonProps = {
  lifeArea: LifeArea;
};

export const LifeAreaRoadmapFilterButton: React.FC<
  LifeAreaRoadmapFilterButtonProps
> = ({ lifeArea }) => {
  const { submit: updateLifeArea } = useUpdateLifeArea();

  const filterDocument = useMemo(
    () =>
      getGoalListControlDocument({
        goalFilterDocument: lifeArea.goalFilterDocument,
        goalSortingMode: lifeArea.goalSortingMode,
      }),
    [lifeArea.goalFilterDocument, lifeArea.goalSortingMode],
  );

  const persist = (next: Partial<GoalFilterDocument>) => {
    const update = getGoalListEntityUpdate({ ...filterDocument, ...next });
    updateLifeArea({ id: lifeArea.id, ...update });
  };

  const handleReset = () => persist({ filters: null });

  return (
    <GoalListFilterButton
      filterDocument={filterDocument}
      hideLifeArea
      supportedFilters={[...filters]}
      supportedGroupByModes={[...groupByModes]}
      filterSections={goalAndProjectFilterSections}
      onUpdate={persist}
      onReset={handleReset}
    />
  );
};
